
import { useState } from 'react';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-sm">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-12">
            <h1 
              className="text-4xl text-white tracking-wide hover:text-blue-400 transition-all duration-300 font-light cursor-pointer"
              style={{ fontFamily: "'Share Tech', sans-serif" }}
            >
              Geosenture
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('solutions')}
              className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
            >
              Solutions
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('advantages')}
              className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
            >
              Advantages
            </button>
            <button 
              onClick={() => scrollToSection('global')}
              className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
            >
              Global Presence
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
            >
              Contact
            </button>
            
            {/* Internal Email Access */}
            <a 
              href="https://email.geosenture.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 border border-blue-400/30 hover:border-blue-400/50 rounded-lg text-blue-300 hover:text-blue-200 transition-all duration-300 text-sm font-light cursor-pointer group"
            >
              <i className="ri-mail-line text-sm group-hover:scale-110 transition-transform"></i>
              <span>Email</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white/80 hover:text-white transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md border-t border-white/10 md:hidden">
            <div className="px-6 py-4 space-y-4">
              <button 
                onClick={() => {
                  scrollToSection('solutions');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
              >
                Solutions
              </button>
              <button 
                onClick={() => {
                  scrollToSection('about');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
              >
                About
              </button>
              <button 
                onClick={() => {
                  scrollToSection('advantages');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
              >
                Advantages
              </button>
              <button 
                onClick={() => {
                  scrollToSection('global');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
              >
                Global Presence
              </button>
              <button 
                onClick={() => {
                  scrollToSection('contact');
                  setIsMenuOpen(false);
                }}
                className="block w-full text-left text-white/80 hover:text-white transition-colors text-sm font-light cursor-pointer"
              >
                Contact
              </button>
              
              {/* Mobile Email Access */}
              <a 
                href="https://email.geosenture.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 w-full text-left px-4 py-3 bg-blue-600/20 hover:bg-blue-600/30 border border-blue-400/30 hover:border-blue-400/50 rounded-lg text-blue-300 hover:text-blue-200 transition-all duration-300 text-sm font-light cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="ri-mail-line text-lg"></i>
                <span>Internal Email Access</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
